import _compact from "lodash/compact";
import { CAMPAIGN_ID } from "../../../constants";

const TEXT = {
    ERRORS: {
        CREDIT_CHECK_ERROR:
            "En feil har oppstått ved kredittsjekk. Vennligst prøv igjen, eller ta kontakt med support.",
        CUSTOMER_CONTACT_INFO_ERROR:
            "En feil har oppstått ved lagring av kontaktinfo. Vennligst prøv igjen, eller ta kontakt med kundeservice hvis det vedvarer.",
        RETAILER_LOOKUP_ERROR:
            "En feil har oppstått ved legitimering. Vennligst prøv igjen, eller ta kontakt med kundeservice hvis det vedvarer.",
        FETCH_PHONE_NUMBER: "Kunne ikke hente tilgjengelige numre. Vennligst last siden på nytt for å prøve igjen.",
        MAX_NUMBER_OF_NEW_NUMBERS_REACHED: "Grensen for hvor mange nye mobilnummer man kan ha i en bestilling er nådd.",
        INVALID_PHONE_NUMBER_FORMAT:
            "Mobilnummeret ser ut til å være galt. Har du tastet riktig? Nummeret er 8 siffer langt, starter med 4 eller 9 og skal skrives uten mellomrom.",
        CHECK_PHONE_NUMBER: "En feil oppstod ved sjekk av mobilnummeret.",
        SUBMIT_ERROR: "En feil oppstod ved innsending av ordre. Vennligst prøv igjen.",
        ORDER_TYPE_SELECTION_ERROR: "Det oppsto en feil under forsøket på å fortsette. Prøv på nytt.",
    },
    PERSONAL_DETAILS: {
        PHONENUMBER: {
            YOUR_NUMBER: "Ditt mobilnummer",
            FETCHING_NUMBERS: "Henter tilgjengelige mobilnummer",
        },
        VERIFICATION: {
            NEW_NUMBER_ABOVE_LIMIT: "Nytt mobilnummer er ikke tilgjengelig ved kjøp av denne telefonen.",
        },
        FIRSTNAME: "Fornavn",
        LASTNAME: "Etternavn",
        STREET: "Gateadresse",
        POSTCODE: "Postnummer",
        CITY: "Poststed",
        BIRTHDATE: "Fødselsdato",
        EMAIL: "E-post",
        EMAIL_HELP_TEXT_TELIA_TRYGG: "En aktiveringslenke vil bli sendt til denne e-postadressen",
        NUMBER_SHOULD_NOT_BE_LISTED_IN_CATALOG: "Skjul nummeret fra kataloghjelpetjenestene",
        ACTIVATE_TELIA_TRYGG_LATER: (isEmailTakenForTeliaTrygg?: boolean, isEmailTakenForTeliaSky?: boolean) =>
            `Kunden aktiverer  ${_compact([
                isEmailTakenForTeliaTrygg ? "Telia Trygg" : undefined,
                isEmailTakenForTeliaSky ? "Telia Sky" : undefined,
            ]).join(" og ")} senere på Min Side eller App`,
        SECRET_NUMBER: "Kjøp hemmelig nummer (20,-/md.)",
    },
    ADD_MEMBER: {
        NEXT_USER_BUTTON: "Klar for neste bruker",
        FINAL_USER_BUTTON: "Neste",
        TELIA_X_SERVICE: {
            UNIQUE_EMAIL: (
                isEmailTakenForTeliaTrygg?: boolean,
                isEmailTakenForTeliaSky?: boolean,
                isTeliaTryggSubscription?: boolean,
            ) => {
                if (isTeliaTryggSubscription) {
                    return "E-post adressen må være unik per bruker av Telia Trygg. Vennligst velg en annen e-post for å legge til.";
                }

                return `Hver bruker må ha en unik e-postadresse i ${_compact([
                    isEmailTakenForTeliaTrygg ? "Telia Trygg" : undefined,
                    isEmailTakenForTeliaSky ? "Telia Sky" : undefined,
                ]).join()}. Velg en annen e-post, eller huk av nedenfor for å aktivere senere via Min Side.`;
            },
        },
        CAMPAIGN: {
            // Keep one for reference to campaigns in the future
            [CAMPAIGN_ID.VPL_3]: {
                IMG_SRC: "/shop/assets/img-static/campaign/viaplay-logo.svg",
                IMG_ALT: "Viaplay logo",
                DESCRIPTION: (aboName: string) =>
                    `Med ${aboName} kan kunde få Viaplay Film & Serier uten ekstra kostnad i 3 måneder.`,
                DISCLAIMER:
                    "Etter prøveperioden vil abonnementet løpe videre til 139,- kr/md. Abonnementet kan avsluttes når kunden vil.",
                OPTION: "Ja, legg til 3 md. Viaplay uten ekstra kostnad.",
                NOT_ALLOWED: "Denne tjenesten har kunden allerede benyttet tidligere og kan derfor ikke legges til.",
            },
        },
        RADIO_GROUP: {
            LABEL: "Hvem skal bruke abonnementet?",
            MEG_SELV: "Kunde / Eier",
            NOEN_ANDRE: "Noen andre",
        },
    },
} as const;

export default TEXT;
